import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
type FaqItemProps = {
  question: string;
  answer: string | JSX.Element;
};
export const FaqItem = ({
  question,
  answer
}: FaqItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border border-[#E5C1A9] rounded-xl overflow-hidden" data-id="element-423">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-6 text-left bg-white hover:bg-[#FFFBF6] transition-colors" data-id="element-424">
        <span className="text-lg font-medium text-[#6B4B3E]" data-id="element-425">{question}</span>
        <ChevronDownIcon size={20} className={`text-[#D4A088] transform transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-426" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-40' : 'max-h-0'}`} data-id="element-427">
        <div className="p-6 pt-0 text-[#6B4B3E]/80" data-id="element-428">{answer}</div>
      </div>
    </div>;
};